(function () {
    "use strict";

    angular.module("app").factory("infiniteScrollService", InfiniteScrollService);

    InfiniteScrollService.$inject = ["$window",];
    function InfiniteScrollService($window) {
        const keys = {
            SortBy: 'Sorting',
        };

        const containerSelector = "div[infinitescroll]";

        return {
            ParseFilter: parseFilter,
            UpdateUrl: updateUrl,
            ScrollToTop: scrollToTop
        };

        function parseFilter() {
            const urlParams = new URLSearchParams($window.location.search);

            let filters = Object.entries(Object.fromEntries(urlParams));

            for (let filter of filters) {
                filter[1] = filter[1].toLowerCase() === "false" || filter[1].toLowerCase() === "true" ? JSON.parse(filter[1].toLowerCase()) : filter[1];
            }

            const parameters = Object.fromEntries(filters);

            const parsed = {
                Filter: { ...parameters },
                SortBy: !parameters.Sorting ? [] : JSON.parse(decodeURIComponent(parameters.Sorting))
            };

            delete parsed.Filter.PageNumber;
            delete parsed.Filter.Sorting;

            return parsed;
        }

        /**
         * Updates the URL parameters without reloading and without polluting the history
         * @param {Object} filter The filtering information
         * @param {Object} pageAndSort The page and sorting settings
         */
        function updateUrl(filter, pageAndSort) {
            
            const urlParameters = { ...filter };
            urlParameters[keys.SortBy] = encodeURIComponent(JSON.stringify(pageAndSort.SortBy));

            const current = getClearedUrlObject();

            for (const key in urlParameters) {
                let value = coerceParameter(urlParameters, key);

                current.searchParams.set(key, value);
            }

            $window.history.replaceState({}, "", current);
        }

        /**
         * Coerces a GET parameter in a safe format
         */
        function coerceParameter(urlParameters, key) {
            let value = urlParameters[key];
            if (Array.isArray(value))
                value = value.join();
            return value;
        }

        /**
         * Creates an ES URL object and clears the searchParams
         * @returns 
         */
        function getClearedUrlObject() {
            const current = new URL($window.location);

            // Important: The URLSearchParams.delete function doesn't work When iterating it
            // for this reason we get the keys in a separate array and delete them
            const keys = Array.from(current.searchParams.keys());
            for (const key of keys)
                current.searchParams.delete(key);

            return current;
        }

        function scrollToTop() {

            const target = angular.element(containerSelector);

            if (!target || target.length === 0)
                return;
            
            target[0].scrollTop = 0;
        }
    }
})();